<template>
  <div>
    <v-form ref="form" v-model="valid">
      <v-row justify="center"  class="pt-xl-0 pt-lg-0 pt-md-0 pt-sm-3 pt-3" no-gutters>
        <v-col xl="12" lg="12" md="12" sm="10" cols="12">
          <v-row justify="center" class="px-xl-3 px-lg-3 px-md-3 px-sm-0 px-0">
            <v-col cols="12">
              <v-file-input
                v-model="chosenFiles"
                show-size
                chips
                label="Fórmulas"
                :rules="!sendLater ? fileRules : []"
                multiple
                solo
                dense>
              </v-file-input>
            </v-col>
            <v-col cols="12">
              <v-checkbox class="mt-n6" v-model="sendLater" dense hide-details>
                <template v-slot:label>
                  <div class="px-1 subtitle-2 grey--text text--darken-3">
                    Enviaré después mi fórmula, podrás enviarla al correo
                    <span class="font-weight-bold">{{ email }}</span>
                    o por medio de WhatsApp al número
                    <span class="font-weight-bold">+57 {{ phone.cell_phone }}</span>.
                  </div>
                </template>
              </v-checkbox>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row justify="center" class="mt-6" no-gutters v-if="showAction">
        <v-col xl="12" lg="12" md="12" sm="10" cols="12">
          <v-row justify="end" no-gutters class="ml-lg-7 ml-xl-7">
            <v-col xl="6" lg="6" md="12" sm="12" cols="12">
              <v-btn class="text-none" block height="48" color="blue darken-1" elevation="0" :dark="valid" @click="validateAction" :disabled="!valid">
                Continuar
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { PHONE, EMAIL } from '@/config/local-info'

export default {
  name: 'FormulaForm',
  props: {
    showAction: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      valid: true,
      chosenFiles: null,
      sendLater: false,
      fileRules: [
        v => !!v || 'Requerido',
        v => (v && v.length <= 5) || 'Puede cargar un máximo de 5 archivos'
      ],
      phone: PHONE,
      email: EMAIL
    }
  },
  computed: {
    ...mapState('product', ['_product'])
  },
  methods: {
    validate () {
      this.$refs.form.validate()
      return { valid: this.valid, chosenFiles: this.chosenFiles }
    },
    validateAction () {
      if (this.$refs.form.validate()) {
        this.$emit('close', this.chosenFiles)
      }
    }
  },
  watch: {
    sendLater: function (value) {
      this.chosenFiles = null
    }
  }
}
</script>
